import { AsyncPipe } from '@angular/common';
import { Component } from '@angular/core';
import { ModalComponent } from '@app/partials/modal/modal.component';
import { ConfirmationModalService } from '@app/partials/modal/confirmation-modal.service';

@Component({
  selector: 'app-confirmation-modal',
  standalone: true,
  imports: [AsyncPipe, ModalComponent],
  template: `
    @if (service.state$ | async; as modal) {
      <app-modal
        [show]="true"
        [title]="modal.title"
        [confirmButtonLabel]="modal.confirmLabel"
        [closeButtonLabel]="modal.cancelLabel"
        [confirmButtonStyle]="modal.confirmButtonStyle"
        [showCloseAction]="modal.showCancel"
        [compact]="true"
        (onClose)="service.resolve(false)"
        (onConfirm)="service.resolve(true)"
      >
        <div class="whitespace-pre-line">
          {{ modal.message }}
        </div>
      </app-modal>
    }
  `,
})
export class ConfirmationModalComponent {
  constructor(public service: ConfirmationModalService) {}
}
